export const setClientHandle = (value) => ({
  type: 'SET_CLIENT_HANDLE',
  payload: value,
});

export const setWebsiteUrl = (value) => ({
  type: 'SET_WEBSITE_URL',
  payload: value,
});
